/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MSGraphChannel } from '../models/MSGraphChannel';
import type { MSGraphChat } from '../models/MSGraphChat';
import type { MSGraphTeam } from '../models/MSGraphTeam';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MsTeamsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Joined Teams
   * 사용자가 참여 중인 MS Teams 팀 목록을 조회합니다.
   *
   * Args:
   * integration (models.Integration): 현재 사용자의 MS Teams 연동 정보.
   * ms_teams_service (MSTeamsService): MS Teams 서비스 로직을 처리하는 서비스.
   *
   * Returns:
   * list[schemas.MSGraphTeam]: 사용자가 참여 중인 팀의 목록.
   * @param slug
   * @returns MSGraphTeam Successful Response
   * @throws ApiError
   */
  public getJoinedTeamsV1WorkspaceSlugIntegrationsMsTeamsTeamsJoinedGet(
    slug: string
  ): CancelablePromise<Array<MSGraphTeam>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations/ms-teams/teams/joined',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Channels
   * 특정 팀의 채널 목록을 조회합니다.
   *
   * Args:
   * integration (models.Integration): 현재 사용자의 MS Teams 연동 정보.
   * ms_teams_service (MSTeamsService): MS Teams 서비스 로직을 처리하는 서비스.
   * team_id: 채널 목록을 얻어올 팀 ID.
   *
   * Returns:
   * list[schemas.MSGraphChannel]: 특정 팀의 채널 목록.
   * @param teamId
   * @param slug
   * @returns MSGraphChannel Successful Response
   * @throws ApiError
   */
  public getChannelsV1WorkspaceSlugIntegrationsMsTeamsTeamsTeamIdChannelsGet(
    teamId: string,
    slug: string
  ): CancelablePromise<Array<MSGraphChannel>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations/ms-teams/teams/{team_id}/channels',
      path: {
        team_id: teamId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Chats
   * 사용자가 참여 중인 MS Teams 채팅 목록을 조회합니다.
   * 1:1, group, 모임 타입 채팅방을 모두 포함합니다.
   *
   * Args:
   * integration (models.Integration): 현재 사용자의 MS Teams 연동 정보.
   * ms_teams_service (MSTeamsService): MS Teams 서비스 로직을 처리하는 서비스.
   *
   * Returns:
   * list[schemas.MSGraphChat]: 사용자가 참여 중인 채팅방 목록.
   * @param slug
   * @returns MSGraphChat Successful Response
   * @throws ApiError
   */
  public getChatsV1WorkspaceSlugIntegrationsMsTeamsChatsGet(
    slug: string
  ): CancelablePromise<Array<MSGraphChat>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations/ms-teams/chats',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
